import React, { useEffect, useState } from 'react';
import { FormSelect, FilterWidget, MasterDetailForm, FormSubmitButton, Button, usePromise, OptionProps, FormNumber, FormRangePicker, FormInput, CompositeView, SimpleView } from '@digital/ui';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllAreasOptions } from '@app/api/area';
import { getAllDepartamentoOptions } from '@app/api/departamento';
import { useActions } from 'easy-peasy';
import { getAllFornecedoresOptions } from '@app/api/fornecedor';
import { getResonsavelMRNOptions, getAllContratoOptions, getAllUserDashboardOptions } from '@app/api/dashboardContratos';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { getAllStatusMedicaoOptions, getAllStatusAutorizacaoPagamentoOptions, getAllStatusAutorizacaoOptions } from '@app/api/status';

const FiltroMedicaoDashboard = (props: { onSearch: Function; }) => {
  const { onSearch } = props;
  const [usuarioDefault, setUserDefault] = useState<string>();
  const [diretorioOptions] = usePromise(getAllDiretoriasOptions, [], [] as OptionProps[]);
  const [areaOptions] = usePromise(getAllAreasOptions, [], [] as OptionProps[]);
  const [departamentoOption] = usePromise(getAllDepartamentoOptions, [], [] as OptionProps[]);
  const [fornecedorOptions] = usePromise(getAllFornecedoresOptions, [], [] as OptionProps[]);
  const [gestorMrnOptions] = usePromise(getAllUserDashboardOptions, [], [] as OptionProps[]);
  const [constratosOptions] = usePromise(getAllContratoOptions, [], [] as OptionProps[]);
  const [statusBoletimMedicaoOptions] = usePromise(getAllStatusMedicaoOptions, [], [] as OptionProps[]);
  const [statusAutorizacaoPagamentoOptions] = usePromise(getAllStatusAutorizacaoPagamentoOptions, [], [] as OptionProps[]);
  const [statusAutorizacaoOptions] = usePromise(getAllStatusAutorizacaoOptions, [], [] as OptionProps[]);


  const limparFormulario = () => {
    const elementos = document.getElementsByClassName('ant-select-selection__clear');
    if (elementos != undefined && elementos.length > 0) {
      for (var i = 0; i < elementos.length; i++) {
        elementos[i].click();
      }
    }

    const elementosCalendario = document.getElementsByClassName('anticon anticon-close-circle ant-calendar-picker-clear');
    if (elementosCalendario != undefined && elementosCalendario.length > 0) {
      for (var i = 0; i < elementosCalendario.length; i++) {
        elementosCalendario[i].click();
      }
    }

    onSearch();
  };


  return (
    <MasterDetailForm
      initialValues={{}}
      onSubmit={onSearch}>
      <FilterWidget
        active={[]}
        title="Filtro do Dashboard"
        actions={[
          <Button
            type="link"
            style={{ marginLeft: '5px' }}
            onClick={() => {
              limparFormulario();
            }}
            icon="editing-trash"
            size="small">
            Limpar
          </Button>,
          <FormSubmitButton type="primary" icon={'commons-search'}>Pesquisar</FormSubmitButton>
        ]}>

        <div className="ant-row">

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {

              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="diretorias"
            id="diretorias"
            label="Diretoria"
            options={diretorioOptions}
            span={4}
            allowClear
          />

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="areas"
            id="areas"
            label="Área"
            options={areaOptions}
            span={4}
            allowClear
          />
        </div>
        <div className="ant-row">

          {gestorMrnOptions.length > 1 ? (
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              mode="multiple"
              name="responsaveis"
              id="responsaveis"
              label="Responsável MRN"
              options={gestorMrnOptions}
              span={4}
              allowClear
            />
          ) : (
            <FormInput
              name="responsaveis"
              id="responsaveis"
              label="Responsável MRN"
              value={usuarioDefault}
              span={4}
              disabled={true}
            />
          )}


          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="contratos"
            id="contratos"
            label="Contratos"
            options={constratosOptions}
            span={4}
            allowClear
          />

        </div>
        <div className="ant-row">

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="fornecedores"
            id="fornecedores"
            label="Fornecedor"
            options={fornecedorOptions}
            span={4}
            allowClear
          />

          <FormRangePicker
            label="Período"
            startName="dataInicial"
            endName="dataFinal"
            format={dateFormat}
            span={4}
          />

        </div>

        <div className="ant-row">

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="statusBoletimMedicao"
            id="statusBoletimMedicao"
            label="Status Boletim de Medição"
            options={statusBoletimMedicaoOptions}
            span={4}
            allowClear
          />


          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="statusAtutorizacasoPagamento"
            id="statusAtutorizacasoPagamento"
            label="Status Autorização/Pagamento"
            options={statusAutorizacaoPagamentoOptions}
            span={4}
            allowClear
          />

        </div>


        <div className="ant-row">

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="statusAutorizacaoMathing"
            id="statusAutorizacaoMathing"
            label="Status Autorização Matching"
            options={statusAutorizacaoOptions}
            span={4}
            allowClear
          />

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            mode="multiple"
            name="departamento"
            id="departamento"
            label="Departamento"
            options={departamentoOption}
            span={4}
            allowClear
          />
        </div>

      </FilterWidget>
    </MasterDetailForm>
  );
};

export default FiltroMedicaoDashboard;





